import { Table } from "reactstrap";
const InternalNotesTable = ({ orderNote }) => {
  return (
    <div className="modern-table-container mt-4">
      <div className="settings-card shadow-sm border-0 overflow-hidden" style={{ borderRadius: '12px' }}>
        <div className="bg-primary-soft p-3 border-bottom d-flex align-items-center gap-2">
          <h5 className="mb-0 fw-bold text-dark fs-15">Internal Notes</h5>
        </div>
        {orderNote ? (
          <Table
            responsive
            bordered
            className="modern-table modern-table-sm mb-0"
            style={{ fontSize: '13px' }}
          >
            <thead style={{ backgroundColor: "#00509d2E" }}>
              <tr>
                <th className="align-middle">Note Content</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="align-middle py-3">
                  <div className="fs-14 text-dark lh-base">
                    {orderNote}
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>
        ) : (
          <div className="text-center py-5 bg-white text-muted fs-14">
            <div className="opacity-50">No internal notes found for this document.</div>
          </div>
        )}
      </div>
    </div>
  );
};


export default InternalNotesTable;
